export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14320.b6e34d5a.jpg";